export default __webpack_public_path__ + "static/media/logo.fc4fbc77.svg";